// extracted by mini-css-extract-plugin
export default {"descendantUrls":"_258f2l2KI7GbZqn4-XCxs7"};